import React from "react";
import Highlight from "../highlight";
import Text from "../text";
import Code from '../code';

interface Props {
    primaryColor: string;
    secondaryColor: string;
    primaryFont: 'basis' | 'plain' | 'maison-neue' | 'fifties-cond-med' | 'pp';
    secondaryFont: 'basis' | 'plain' | 'maison-neue' | 'fifties-cond-med' | 'pp';
    line3Props: {
        fontSize: number;
        fontWeight?: number;
    };
    sizeFactor: number;
    codes: {
        code: string;
        platinum: boolean;
    }[];
}

const TwoNonPlatinum = ({ primaryColor, secondaryColor, primaryFont, secondaryFont, line3Props, sizeFactor, codes }: Props) => {
    return (
        <Highlight
            padding="14px 8px 8px"
            bg={primaryColor}
            color={secondaryColor}
            className="flex-column align-items-start w-100 mt-2 line-3 anim anim-fade-in"
            style={{
                marginBottom: `10px`
            }}
        >
            <Text fontFamily={primaryFont} fontSize={`${line3Props.fontSize * sizeFactor}px`} fontWeight={line3Props.fontWeight || 400} color={secondaryColor}>
                2 CÓDIGOS 2X1
            </Text>
            <Text fontFamily={secondaryFont} fontSize="10px" color={secondaryColor} className="mt-2">
                VÁLIDO EN EXPERIENCIA TRADICIONAL O MARKET
            </Text>
            <Code bg={secondaryColor} color={primaryColor} className="mt-2 anim anim-fade-in">
                {codes[0].code}
            </Code>
            <Code bg={secondaryColor} color={primaryColor} className="mt-2 anim anim-fade-in">
                {codes[1].code}
            </Code>
            {/* <Text fontFamily="maison-neue" fontSize="10px" color={secondaryColor} className="mt-2">
                Canjéalo en canales digitales
            </Text> */}
        </Highlight>
    )
}

export default TwoNonPlatinum;